import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';
import { baseStringActions } from 'actions/api/baseStrings';
import MaterialTextField from 'components/util/materialTextField';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { validate } from 'reducers/form/validate';
import { RaisedButton } from 'material-ui';
import AddStringRow from './addStringRow';
import { debounce } from 'lodash';
import LodIcon from 'components/util/lodIcon';
import Pagination from 'components/pagination';
import MaterialCheckbox from 'components/util/materialCheckbox';
import { uuid } from 'util/baseUtil';

class AddStrings extends Component {
  state = { page: 1, searchString: '' };

  componentWillMount() {
    this.searchStrings();
  }

  searchStrings = ({ background } = {}) => {
    this.props.dispatch(
      baseStringActions.search({
        data: {
          meta: {
            pagination: { page: this.state.page },
            text_search: this.state.searchString.trim() || null
          }
        },
        background
      })
    );
  };

  debouncedSearch = debounce(this.searchStrings, 300);

  onSave = async data => {
    if (data.is_classification) {
      data.key = uuid();
    }

    this.props.reset();
    try {
      await this.props.dispatch(
        baseStringActions.save({
          data,
          background: true,
          backgroundExtras: { created_at: Date.now() }
        })
      );
    } catch (e) {}
    this.setState({ page: 1, searchString: '' });

    setTimeout(() => {
      this.searchStrings({ background: true });
    });
  };

  onSearchChange = ({ target }) => {
    this.setState({ searchString: target.value, page: 1 });

    setTimeout(this.debouncedSearch);
  };

  onPageChange = page => {
    this.setState({ page });
    setTimeout(this.searchStrings);
  };

  handleKeyInput = ({ target }) => {
    let key = target.value.toUpperCase();
    key = key.replace(' ', '_');
    key = key.replace(/\W/g, '');
    setTimeout(() => {
      this.props.change('key', key);
    });
  };

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <div>Add Strings</div>
          <div className={styles.search}>
            <LodIcon icon="search" />
            <div className={styles.searchInput}>
              <MaterialTextField
                value={this.state.searchString}
                onChange={this.onSearchChange}
                hintText="Search by key or english value"
              />
            </div>
          </div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <form onSubmit={this.props.handleSubmit(this.onSave)}>
              <div className="row">
                <div className="col-3">
                  <Field
                    onChange={this.handleKeyInput}
                    component={MaterialTextField}
                    name="key"
                    hintText="Key (Leave blank for scope library)"
                    noValidate
                  />
                </div>
                <div className="col-3">
                  <Field
                    component={MaterialTextField}
                    name="value"
                    hintText="English string*"
                    noValidate
                  />
                </div>
                <div className="col-6">
                  <div className={styles.descriptionWrapper}>
                    <Field
                      component={MaterialTextField}
                      name="description"
                      hintText="Description"
                    />
                    <div className={styles.checkboxWrapper}>
                      <MaterialCheckbox
                        value={this.props.is_classification}
                        onChange={(e, val) => {
                          this.props.change(
                            'is_classification',
                            !this.props.is_classification
                          );
                        }}
                      />
                      Scope Library
                    </div>
                    <div>
                      <RaisedButton
                        label="Save"
                        type="submit"
                        primary
                        disabled={!this.props.valid}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className={styles.tableWrapper}>
            <div className={styles.pagination}>
              <Pagination
                pagination={this.props.pagination}
                onChange={this.onPageChange}
              />
            </div>
            <div className={styles.headerWrapper}>
              <table>
                <colgroup>
                  <col width="20%" />
                  <col width="40%" />
                  <col width="40%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>Key</th>
                    <th>English</th>
                    <th>Description</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className={styles.bodyWrapper}>
              <table>
                <colgroup>
                  <col width="20%" />
                  <col width="40%" />
                  <col width="40%" />
                </colgroup>
                <tbody>
                  {this.props.baseStrings
                    .sort(
                      (a, b) =>
                        +new Date(b.created_at) - +new Date(a.created_at)
                    )
                    .map(string => {
                      return <AddStringRow key={string.id} string={string} />;
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validations = {
  required: {
    fields: ['value']
  }
};

AddStrings = reduxForm({
  form: 'AddStrings',
  validate: values => {
    return validate(values, validations);
  }
})(AddStrings);

export default connect(state => {
  return {
    baseStrings: state.baseStrings.list,
    pagination: state.baseStrings.meta.pagination,
    is_classification: formValueSelector('AddStrings')(
      state,
      'is_classification'
    )
  };
})(AddStrings);



// WEBPACK FOOTER //
// ./src/components/dashboard/developerDashboard/addStrings/index.js